import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Hero from "@/components/site/Hero";
import PageFlipCatalogue from "@/components/site/PageFlipCatalogue";
import InteractiveNavigationBubbles from "@/components/site/InteractiveNavigationBubbles";
import ProcessVideoSlideshow from "@/components/site/ProcessVideoSlideshow";
import SEOHead from "@/components/site/SEOHead";
import SocialMediaEmbeds from "@/components/site/SocialMediaEmbeds";
import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";

const Index = () => {
  const { t } = useLanguage();
  
  useEffect(() => {
    document.documentElement.classList.add('snap-page');
    return () => {
      document.documentElement.classList.remove('snap-page');
    };
  }, []);
  return (
    <div className="min-h-screen bg-gradient-subtle">
      <SEOHead
        title="MagicDoor | Uși, scări, mobilier din lemn masiv la comanda. Tu vii cu ideea, noi o punem în practică."
        description="Magic Door realizează uși, mobilier, parchet și ferestre din lemn premium, personalizate. Lucrări manuale de calitate din România, Piatra Neamț, adaptate casei tale."
        canonicalPath="/"
        image="/lovable-uploads/new-logo.png"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'MagicDoor',
          url: 'https://magicdoor.ro',
          description: 'Producător de uși premium, mobilier personalizat și semifabricate din lemn masiv. Calitate superioară din Piatra Neamț, România.',
          sameAs: [
            'https://instagram.com/magicdoor.ro',
            'https://tiktok.com/@magicdoor1999'
          ],
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Bulevard General Nicolae Dascalescu, nr 6B',
            addressLocality: 'Piatra Neamț',
            postalCode: '610136',
            addressRegion: 'Neamț',
            addressCountry: 'RO',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: '46.9286',
            longitude: '26.3811'
          },
          contactPoint: [
            {
              '@type': 'ContactPoint',
              telephone: '+40728847582',
              contactType: 'customer service',
              email: 'Productie@magicdoor.ro',
              availableLanguage: ['ro', 'en'],
              areaServed: 'RO'
            }
          ],
          priceRange: '$$',
          openingHoursSpecification: [
            {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
              opens: '08:00',
              closes: '17:00'
            },
            {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: 'Saturday',
              opens: '09:00',
              closes: '13:00'
            }
          ]
        }}
      />

      <Header />

      <Hero />

      <PageFlipCatalogue />

      <InteractiveNavigationBubbles />

      <ProcessVideoSlideshow />

      <main className="container p-0">
        <SocialMediaEmbeds />
      </main>

      <Footer />
    </div>
  );
};

export default Index;
